import React from 'react'
import "../styles/Process.css"
const Process = () => {
    return (
        <div>
            <article class="foodprocessingHaro">
                <div>
                    <h2> How is Wood/Cold Pressed oil Extracted?</h2>
                    <h5>Oil seeds are pressed in a Traditional Marachekku ( Wooden Press) at Room temperature No External heat is applied Preserving Natural nutrients and Aroma</h5>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="road-map-main">
                            <div class="road-map-wrapper">
                                <div class="road-map-circle">
                                    <span class="road-map-circle-text d-flex align-items-center justify-content-center">Step
                                        1</span>
                                </div>
                                <div class="road-map-card">
                                    <h4 class="card-head"><span>🫘
                                    </span> Seed Selection</h4>
                                    <p class="card-text">
                                        High-quality seeds are selected based on the type of oil needed (e.g., peanuts, sesame).
                                        This ensures the purity, taste, and nutritional value of the final oil.
                                    </p>
                                </div>
                            </div>
                            <div class="road-map-wrapper">
                                <div class="road-map-circle">
                                    <span class="road-map-circle-text d-flex align-items-center justify-content-center">Step
                                        2</span>
                                </div>
                                <div class="road-map-card">
                                    <h4 class="card-head"><span>🌤</span>Cleaning & Drying </h4>
                                    <p class="card-text">
                                        Seeds are thoroughly cleaned and dried to remove dirt, moisture, and impurities.
                                        This step helps in producing hygienic and long-lasting oil.


                                    </p>
                                </div>
                            </div>
                            <div class="road-map-wrapper">
                                <div class="road-map-circle">
                                    <span class="road-map-circle-text d-flex align-items-center justify-content-center">Step
                                        3</span>
                                </div>
                                <div class="road-map-card">
                                    <h4 class="card-head"><span>🗜</span>Cold Pressing</h4>
                                    <p class="card-text">
                                        Seeds are pressed in a Traditional Marachekku (Wodden Grinder) at room temperature.
                                        No heat is applied, preserving natural nutrients and aroma.
                                    </p>
                                </div>
                            </div>
                            <div class="road-map-wrapper">
                                <div class="road-map-circle">
                                    <span class="road-map-circle-text d-flex align-items-center justify-content-center">Step
                                        4</span>
                                </div>
                                <div class="road-map-card">
                                    <h4 class="card-head"><span>🔬</span>Natural Filtration</h4>
                                    <p class="card-text">
                                        Immediately after pressing, the oil is stored in food-grade containers to let sediments naturally settle at the bottom.
                                        This process takes about 3 to 5 days.
                                    </p>
                                </div>
                            </div>
                            <div class="road-map-wrapper">
                                <div class="road-map-circle">
                                    <span class="road-map-circle-text d-flex align-items-center justify-content-center">Step
                                        5</span>
                                </div>
                                <div class="road-map-card">
                                    <h4 class="card-head"><span>🥡</span>Storage & Packaging</h4>
                                    <p class="card-text">
                                        The oil is stored in food-grade containers to preserve its quality and freshness. After filtration, it is packed in food-grade bottles, ensuring protection from contamination and extending its shelf life.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    )
}

export default Process;